import { NuxtBase } from './base'

export class NuxtClientBase extends NuxtBase {
  initAppInterceptors() {
    this.gaApp.api.addRequestCallback({
      success: (config) => {
        const token = this.gaApp.services.app.auth.getToken()
        const deviceId = this.gaApp.services.app.main.deviceId

        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }

        if (deviceId) {
          config.headers['plaid-device-id'] = deviceId
        }

        return config
      },
    })

    this.gaApp.api.addResponseCallback({
      success: (response) => {
        return response
      },
      error: (error) => {
        if (error?.status === 401) {
          this.gaApp.services.app.auth.resetAuth()
        }

        return Promise.reject(error)
      },
    })
  }

  /**
   * Метод проверки поддержки media (hover)
   */
  detectHoverMedia() {
    this.gaApp.services.app.browserWindow.detectWindowHoverMedia()
  }

  /**
   * Метод инициализации слушателя события `orientationchange` и `resize`
   */
  initWindowResizeListener() {
    this.gaApp.services.app.browserWindow.bindWindowResizeListeners()
  }

  /**
   * Метод инициализации слушателей для событий
   * keyboard, mousedown, mouseup, click, keydown, focusin
   */
  initKeyboardAndPointerListener() {
    this.gaApp.services.app.browserWindow.bindKeyboardAndPointerListeners()
  }

  /**
   * Метод установки значения текущего разрешения
   */
  initCurrentBreakpoint() {
    this.gaApp.services.app.window.setCurrentBreakpoint()
  }

  /**
   * Метод устанавливает id-сеанса пользователя
   */
  setUserViewGUID() {
    this.gaApp.services.main.user.setUserViewGUID()
  }

  /**
   * Метод инициализации аналитик
   */
  initAnalytics() {
    this.gaApp.analytics.libs.initDataLayer()
    this.gaApp.analytics.libs.initAllWithPermissionsChecks()
  }

  /**
   * Метод, вызывающийся по завершению инициализации приложения
   */
  completeAppInit() {
    this.gaApp.eventBus.publish('module/app/init')

    this.gaApp.stores.app.main.init = true

    const { isSSR, withHover } = this.gaApp.stores.app
    const { currentBreakpoint, windowSize } = this.gaApp.stores.app.window

    this.gaApp.services.app.apm.addLabels({
      isSSR,
      withHover,
      currentBreakpoint,
      ...windowSize,
    })
  }

  /**
   * Метод обработки ошибки инициализации
   *
   * @param {object} error - данные ошибки
   * @param {string} initType - тип инициализируемого приложения
   */
  onInitError(error, initType) {
    console.log(`ошибка ${initType}`, error)

    this.gaApp.stores.app.main.isErrorInit = true

    error.name = initType
    error.fullError = JSON.stringify(error)
    this.gaApp.services.app.apm.captureError(error)
  }

  /**
   * Метод для подгрузки изображений
   */
  async loadSources() {
    try {
      await this.gaApp.services.main.sources.loadSources()
    } catch (error) {
      console.error('Не удалось загрузить splash заставку:', error)
    }
  }

  /**
   * Метод для загрузки призов для рулетки
   */
  async loadRoulettePrizes() {
    try {
      await this.gaApp.services.main.prizes.loadRoulettePrizes()
    } catch (error) {
      console.error('Не удалось загрузить призы для рулетки:', error)
    }
  }
}
